export const BASE_URL = `${process.env.REACT_APP_API_URL}/api/bus`;

export function generateRequestId() {
  return `REQ-${Date.now()}-${Math.random().toString(36).substr(2, 6).toUpperCase()}`;
}